<div class="login_form">


    <div class="logo">
        <img src="../../../../../assets/images/logo/flowtrics_logo.png"  >
    </div>
    <div class="title" >RESET PASSWORD</div>
    <form [formGroup]="resetPasswordForm"  class="fix-mat-form-field" autocomplete="off">


            <mat-form-field class="choose" appearance="fill" fxFlex>
                <mat-label>Old password</mat-label>
                <input matInput [type]="hidenew ? 'password' : 'text'" formControlName="oldPassword" placeholder="Enter old password">
                    <mat-icon  matSuffix (click)="hidenew = !hidenew" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hidenew">{{hidenew ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-hint class="errorpass">Choose a password of at least eight characters, one uppercase, lowercase letter and one number
                </mat-hint>
                <mat-error class="errorpass" >
                    Please enter password
                </mat-error>
            </mat-form-field>

        <mat-form-field appearance="fill" fxFlex>
            <mat-label>New password</mat-label>
            <input matInput [type]="hideold ? 'password' : 'text'" placeholder="Enter new password"
                formControlName="newPassword">
            <span matSuffix (click)="hideold = !hideold" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideold">
                <mat-icon>{{hideold ? 'visibility_off' : 'visibility'}}</mat-icon>
        </span>
        <mat-hint class="errorpass">Choose a password of at least eight characters, one uppercase, lowercase letter and one number
        </mat-hint>
        <mat-error class="errorpass" >
            Please enter password
        </mat-error>
        </mat-form-field>
    </form>

    <button mat-raised-button class="submit-button" color="primary" (click)="resetPassword(resetPasswordForm)">Reset
        Password
    </button>
</div>